




import Vue from "vue";
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";
import {marked} from "marked";

@Component
export default class MarkdownRenderer extends Vue {
    @Prop({required: true}) public source!: string;

    private get renderedMarkdown(): string {
        marked.setOptions({
            breaks: true,
            gfm: true
        });
        return marked.parse(this.source || "");
    }
}
